import { useEffect, useState, useRef } from "react";
import { checkMembershipPermissions } from "../../../redux/permissions/UserPermissions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Modal } from "reactstrap";
import MembershipModel from "../MembershipModel";
import RoleBaseModel from "../RoleBaseModel";
import NotRegisterModel from "../NotRegisterModel";

export default function Access({
  modal,
  setModal,
  pathurl,
  state = null,
  checkpermission = "no-idea",
  hitmethod,
  masterID,
  checkrole = true,
}) {
  const dispatch = useDispatch();
  const role_type = localStorage.getItem("role_type");
  const navigate = useNavigate();
  const token = localStorage.getItem("urexperttoken");
  const [modalPermission, setModalPermission] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [activeModal, setActiveModal] = useState(null); // 'not-registered', 'role-base', 'membership'

  const checkPermissions = async (posttype) => {
    try {
      const response = await dispatch(checkMembershipPermissions(posttype, masterID));
      if (response?.status) {
        setModalPermission(true);
        if (pathurl) {
          navigate(pathurl, state);
        }
        if (hitmethod) {
          if (checkrole && role_type == 2) {
            // hitmethod();
          } else {
            hitmethod();
          }
        }
      } else {
        setErrorMessage(response);
        setActiveModal('membership');
      }
    } catch (error) {
      console.error(error);
    }
  };

  // const handleCheckForJob = () => {
  //   const job = location.pathname.includes("jobdetails");
  //   const project = location.pathname.includes("projectdetails");
  //   const contest = location.pathname.includes("contestdetails");
  //   if (job || project || contest) {
  //     setActiveModal('membership');
  //   } else {
  //     checkaccessss();
  //   }
  // };

  const calledRef = useRef(false);

  useEffect(() => {
    if (modal && !calledRef.current) {
      calledRef.current = true;
      setModalPermission(false);
      checkaccessss();
    }
  }, [modal]);

  const checkaccessss = () => {
    if (!token) {
      setActiveModal('not-registered');
      return;
    }

    if (checkrole && role_type == 2) {
      setActiveModal('role-base');
      return;
    }

    if (role_type == 3 || role_type == 4 || role_type == 2) {
      checkPermissions(checkpermission);
    } else {
      setActiveModal('membership');
    }
  };

  const handleCloseModal = () => {
    setActiveModal(null);
    setModal(false);
  };

  return (
    <div>
      {/* Not Registered Modal - Highest Priority */}
      {modal && activeModal === 'not-registered' && (
        <Modal
          isOpen={modal}
          keyboard={false}
          className="modal-centered popupmodal"
        >
          <NotRegisterModel setModal={handleCloseModal} />
        </Modal>
      )}

      {/* Role Base Modal - Medium Priority */}
      {modal && activeModal === 'role-base' && (
        <Modal
          isOpen={modal}
          keyboard={false}
          className="modal-centered popupmodal rolebase-modal"
        >
          <RoleBaseModel setModal={handleCloseModal} />
        </Modal>
      )}

      {/* Membership Modal - Lowest Priority */}
      {modal && activeModal === 'membership' && !modalPermission && (
        <Modal
          isOpen={modal}
          keyboard={false}
          className="modal-centered popupmodal"
        >
          <MembershipModel setModal={handleCloseModal} errorMessage={errorMessage} checkpermission={checkpermission} />
        </Modal>
      )}
    </div>
  );
}